var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeAvisoVazado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 2.48999L18.0301 15.5H2.97012L10.5001 2.48999ZM1.24012 14.5C0.470121 15.83 1.43012 17.5 2.97012 17.5H18.0301C19.5701 17.5 20.5301 15.83 19.7601 14.5L12.2301 1.48999C11.4601 0.159993 9.54012 0.159993 8.77012 1.48999L1.24012 14.5ZM9.50012 7.49999V9.49999C9.50012 10.05 9.95012 10.5 10.5001 10.5C11.0501 10.5 11.5001 10.05 11.5001 9.49999V7.49999C11.5001 6.94999 11.0501 6.49999 10.5001 6.49999C9.95012 6.49999 9.50012 6.94999 9.50012 7.49999ZM9.50012 12.5H11.5001V14.5H9.50012V12.5Z",
    fill: "#9C8F16"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAvisoVazado);
export default __webpack_public_path__ + "static/media/icone-aviso-vazado.0f283d28d19975b10271fea1fd9dca50.svg";
export { ForwardRef as ReactComponent };